import React, {
  useEffect,
  useState,
  useCallback
} from "react";

import "./CastingDirectorCard.css";

import {
  fetchPublicDirectorStatsApi
} from "../../services/api";

const CastingDirectorCard = ({
  audition
}) => {

  const [
    directorProfile,
    setDirectorProfile
  ] = useState(null);

  const [
    loading,
    setLoading
  ] = useState(false);

  // =========================
  // GET DIRECTOR ID
  // =========================

  const getDirectorId =
    useCallback(() => {

      return (
        audition?.rolePostBy ||
        audition?.created_by ||
        audition?.user_id
      );

    }, [audition]);



  // =========================
  // LOAD DATA
  // =========================

  const loadDirectorData =
    async () => {

      try {

        const directorId =
          getDirectorId();

        if (!directorId) {

          console.error(
            "❌ Director ID missing"
          );

          return;
        }

        console.log(
          "🎬 DIRECTOR ID =>",
          directorId
        );

        setLoading(true);

        const res =
          await fetchPublicDirectorStatsApi(
            directorId
          );

        console.log(
          "🎬 DIRECTOR API RESPONSE =>",
          res.data
        );

        if (
          res?.data?.success
        ) {

          setDirectorProfile(
            res.data.data
          );

        }

      } catch (err) {

        console.error(
          "❌ DIRECTOR CARD ERROR =>",
          err
        );

      } finally {

        setLoading(false);

      }
    };


  // =========================
  // EFFECT
  // =========================

  useEffect(() => {

    if (audition) {

      loadDirectorData();

    }

  }, [audition]);



  // =========================
  // IMAGE
  // =========================

  const getImageUrl = () => {

    if (
      directorProfile?.profileImage
    ) {

      return directorProfile.profileImage;

    }

    return "https://cdn-icons-png.flaticon.com/512/149/149071.png";
  };



  return (

    <div className="casting-profile-card">

      <div className="casting-cover-glow"></div>


      {/* TOP */}

      <div className="casting-profile-top">

        <div className="casting-profile-img-container">

          <img
            src={getImageUrl()}
            alt="Director"
            className="casting-profile-img"

            onError={(e) => {

              e.target.onerror = null;

              e.target.src =
                "https://cdn-icons-png.flaticon.com/512/149/149071.png";
            }}
          />

        </div>


        <div className="casting-profile-info">

          <h3>

            {
              directorProfile?.name ||

              "Casting Director"
            }

          </h3>

          <span>
            Casting Director
          </span>

        </div>

      </div>


      {/* BIO */}

      <p className="casting-bio">

        {
          directorProfile?.aboutAgency ||

          "Award-winning casting professional helping actors connect with premium film & OTT projects."
        }

      </p>


      {/* STATS */}

      <div className="casting-stats-grid">

        <div className="stat-box">

          <strong>

            {
              loading
                ? "..."
                : directorProfile?.totalRoles || 0
            }

          </strong>

          <span>
            Total Roles
          </span>

        </div>


        <div className="stat-box">

          <strong>

            {
              loading
                ? "..."
                : directorProfile?.totalProjects || 0
            }

          </strong>

          <span>
            Projects
          </span>

        </div>


        <div className="stat-box">

          <strong>
            94%
          </strong>

          <span>
            Success
          </span>

        </div>

      </div>


      {/* BUTTON */}

      <button
        className="casting-connect-btn"
      >

        View Profile

      </button>

    </div>
  );
};

export default CastingDirectorCard;